//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
let d=[[[0,"FixedVector",1,"Direction",0],[0,"TriangleTolerance",1,0]],[[["obj","tolerance","vector"],"Create",{},3,0],[["obj","tolerance","angular_tolerance","vector"],"CreateWithAngleTolerance",{},4,0],[["obj"],"Delete",{},1,0],[["obj","tolerance","vector"],"GetParameter",{},1,0],[["obj","tolerance","vector"],"SetParameter",{},3,0],[["count","solid_bodies","facet_bodies"],"GetObjects",{},0,0]],[]];
SPLM.CAM.PreprocessGeometryBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.PreprocessGeometryBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;